export const USER_REGISTER_REQUEST = "USER_REGISTER_REQUEST";
export const USER_REGISTER_SUCCESS = "USER_REGISTER_SUCCESS";
export const USER_REGISTER_FAIL = "USER_REGISTER_FAIL";
export const USER_REGISTER_FAIL_ACKNOWLEDGE = "USER_REGISTER_FAIL_ACKNOWLEDGE";

export const USER_LOGIN_REQUEST = "USER_LOGIN_REQUEST";
export const USER_LOGIN_SUCCESS = "USER_LOGIN_SUCCESS";
export const USER_LOGIN_FAIL = "USER_LOGIN_FAIL";
export const USER_LOGIN_FAIL_ACKNOWLEDGE = "USER_LOGIN_FAIL_ACKNOWLEDGE";

export const USER_UPDATE_REQUEST = "USER_UPDATE_REQUEST";
export const USER_UPDATE_SUCCESS = "USER_UPDATE_SUCCESS";
export const USER_UPDATE_FAIL = "USER_UPDATE_FAIL";
export const USER_UPDATE_RESET = "USER_UPDATE_RESET";
export const USER_UPDATE_USER_SUCCESS = "USER_UPDATE_USER_SUCCESS";

export const USER_RESET_PASSWORD_REQUEST = "USER_RESET_PASSWORD_REQUEST";
export const USER_RESET_PASSWORD_SUCCESS = "USER_RESET_PASSWORD_SUCCESS";
export const USER_RESET_PASSWORD_FAIL = "USER_RESET_PASSWORD_FAIL";
export const USER_RESET_PASSWORD_FAIL_ACKNOWLEDGE = "USER_RESET_PASSWORD_FAIL_ACKNOWLEDGE";

export const USER_LOGOUT = "USER_LOGOUT";

export const USER_DELETE_REQUEST = "USER_DELETE_REQUEST";
export const USER_DELETE_SUCCESS = "USER_DELETE_SUCCESS";

export const ADMIN_USERS_LIST_REQUEST = "ADMIN_USERS_LIST_REQUEST";
export const ADMIN_USERS_LIST_SUCCESS = "ADMIN_USERS_LIST_SUCCESS";
export const ADMIN_USERS_LIST_FAIL = "ADMIN_USERS_LIST_FAIL";
export const ADMIN_USERS_LIST_RESET = "ADMIN_USERS_LIST_RESET";export const USER_DELETE_FAIL = "USER_DELETE_FAIL";